module.exports = __webpack_public_path__ + "img/air_yellow.ede8a439.svg";